import { defineStore } from 'pinia';
import http from '../api/httpRequest.js'

export default defineStore('groupStore', {
	state: () => {
			return {
				groups: [],
				robotDndSettings: {}
			}
		},
	actions: {
		// 确保机器人DND设置是响应式的
		ensureRobotDndSettings(groupId, robotId) {
			if (!this.robotDndSettings) {
				this.robotDndSettings = {};
			}
			if (!this.robotDndSettings[groupId]) {
				this.robotDndSettings[groupId] = {};
			}
			if (!this.robotDndSettings[groupId][robotId]) {
				this.robotDndSettings[groupId][robotId] = {
					isDnd: false,
					isBlocked: false
				};
			}
			return this.robotDndSettings[groupId][robotId];
		},
		// 设置机器人免打扰状态
		setRobotDnd(groupId, robotId, isDnd) {
			const settings = this.ensureRobotDndSettings(groupId, robotId);
			settings.isDnd = isDnd;
		},
		// 设置机器人屏蔽状态
		setRobotBlocked(groupId, robotId, isBlocked) {
			const settings = this.ensureRobotDndSettings(groupId, robotId);
			settings.isBlocked = isBlocked;
		},
		// 获取机器人免打扰状态
		getRobotDnd(groupId, robotId) {
			const settings = this.ensureRobotDndSettings(groupId, robotId);
			return settings.isDnd;
		},
		// 获取机器人屏蔽状态
		getRobotBlocked(groupId, robotId) {
			const settings = this.ensureRobotDndSettings(groupId, robotId);
			return settings.isBlocked;
		},
		// 重置机器人DND设置
		resetRobotDndSettings() {
			this.robotDndSettings = {};
		},
		setGroups(groups) {
			this.groups = groups;
		},
		addGroup(group) {
			if (this.groups.some(g => g.id == group.id)) {
				this.updateGroup(group)
			} else {
				this.groups.unshift(group);
			}
		},
		removeGroup(id) {
			this.groups.filter(g => g.id == id).forEach(g => g.quit = true);
		},
		updateGroup(group) {
			this.groups.forEach((g, idx) => {
				if (g.id == group.id) {
					// 拷贝属性
					Object.assign(this.groups[idx], group);
				}
			})
		},
		updateTopMessage(id, topMessage) {
			let group = this.findGroup(id);
			if (group) {
				group.topMessage = topMessage;
			}
		},
		setDnd(id, isDnd) {
			let group = this.findGroup(id);
			group.isDnd = isDnd;
		},
		setMute(id, isMuted) {
			let group = this.findGroup(id);
			group.isMuted = isMuted;
		},
		setForbidPrivateChat(id, isForbidPrivateChat) {
			let group = this.findGroup(id);
			group.isForbidPrivateChat = isForbidPrivateChat;
		},		
		clear() {
			this.groups = [];
		},
		loadGroup() {
			return new Promise((resolve, reject) => {
				http({
					url: '/group/list',
					method: 'GET'
				}).then(groups => {
					this.setGroups(groups);
					resolve();
				}).catch(e => {
					reject(e);
				})
			});
		}
	},
	getters: {
		findGroup: (state) => (id) => {
			return state.groups.find(g => g.id == id);
		},
		isGroup: (state) => (id) => {
			return state.groups.filter(g => !g.quit).some(g => g.id == id);
		},
	}
});